import { Button, Link } from '@one-thd/sui-atomic-components';
import React, { memo } from 'react';
import { AddReceiptDrawer } from './add-receipt';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { pushEventInfo } from '../../../utils/analytics';
import { IAddReceipt } from '../../../models/purchase-history';

export const AddReceiptButton = memo(
  ({ svocId, mobile = false, display = 'button' }: IAddReceipt) => {
    const { openAddReceiptDrawer, setOpenAddReceiptDrawer } =
      usePurchaseHistoryContext();

    const handleOnClick = () => {
      pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: { eventName: 'add receipt' },
      });
      setOpenAddReceiptDrawer(true);
    };

    if (display === 'link') {
      return (
        <div data-testid="add-receipt-link">
          <Link component="button" onClick={handleOnClick} variant="body-sm">
            Add Receipt
          </Link>
          <AddReceiptDrawer
            closeDrawer={() => setOpenAddReceiptDrawer(false)}
            isDrawerOpen={openAddReceiptDrawer}
            svocId={svocId}
          />
        </div>
      );
    }

    return (
      <div data-testid="add-receipt-button">
        <Button
          variant={mobile ? 'secondary' : 'primary'}
          onClick={handleOnClick}
        >
          Add Receipt
        </Button>
        <AddReceiptDrawer
          closeDrawer={() => setOpenAddReceiptDrawer(false)}
          isDrawerOpen={openAddReceiptDrawer}
          svocId={svocId}
        />
      </div>
    );
  },
);
